import { InMemoryCache } from "@apollo/client";

/**
 * Read more about Apollo InMemoryCache here:
 * https://www.apollographql.com/docs/react/caching/cache-configuration/
 *
 * NOTE: It's important to always include the "id" fields in each query so that the automatic
 * merging works as expected.
 */
export const cache = new InMemoryCache({
  typePolicies: {
    // This is just the default
    //Query: {
    //  fields: {
    //    company: {
    //      keyArgs: ["id"],
    //      merge: true
    //    },
    //    factory: {
    //      keyArgs: ["id"],
    //      merge: true
    //    },
    //  },
    //},
    //Asset: {
    //  keyFields: ["id"],
    //  fields: {
    //    assetSignals: {
    //      merge(existing = [], incoming) {
    //        // Add incoming assetSignals to the array of existing assetSignals
    //        // The default behavior is to replace the existing array with the incoming array
    //        // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-assignment
    //        return [...existing, ...incoming];
    //      },
    //    },
    //  },
    //},
    LiveStream: {
      keyFields: ["cameraConfigId"],
    },
  },
});
